export default {
    platform: "platform",
    home: "Home",
    index: "Index",
    menu: "Menu",
    video: "Video",
    login: "Login",
    username: "Username",
    password: "Password",
    remember_me: "Remember me",
    change_password: "Change password",
    logout: "Logout",
    search: "Search",
    id: "Id",
    sn: "SN",
    view: "View",
    created_time: "Created time",
    shop: {
        name: "Shop"
    },
    device: {
        device_manage: "Device",
        device_list: "Device list",
        bind_shop: "Bind shop",
        device_type: "Device type",
        bind_time: "Bind time",
        bind: "Bind",
        cancel_bind: "Cancel bind",
        qrcode: "Qrcode"
    },
    dealer: {
        dealer_login: "Dealer login",
        dealer_management_system: "Dealer Management"
    },
    message: {
        welcome: "Welcome!",
        please_enter_username: "Please enter your username",
        please_enter_password: "Please enter your password",
        please_enter_id: "Please enter id",
        please_enter_sn: "Please enter sn",
        please_select: "Please select"
    }
}


// WEBPACK FOOTER //
// ./src/lang/en_US.js